const fishingLocationRawData = [
  '全區域水窪',
  '全區域池塘',
  '區域 1 河流(礦區旁)',
  '區域 1 海邊',
  '區域 2 湖泊(淨水)',
  '區域 2 礦區',
  '區域 2 海邊',
  '區域 3 湖泊(淨水)',
  '區域 3 海邊',
  '區域 3 礦區',
  '城鎮河川(公園旁)',
  '城鎮海邊',
  '古老湖',
  '釣客之島河川',
  '釣客之島海邊',
];

export default fishingLocationRawData;